import { getPagePath } from "@nanostores/router";
import { PropsWithChildren, ReactElement } from "react";

import { $router } from "../../stores/router";
import { Button } from "../catalyst/Button";

export const EntitySelector = ({
  children,
  entityId,
}: PropsWithChildren<{ entityId: string }>): ReactElement => {
  return (
    <Button
      className="font-inherit rounded border border-blue-400/60 p-1 text-sm text-blue-400 underline decoration-blue-400 transition-all duration-200 hover:border-blue-400 hover:bg-blue-400/10"
      href={getPagePath($router, "entityEdit", { entityId })}
      plain
      rel="noopener noreferrer"
      size="xs"
      target="_blank"
    >
      {children}
    </Button>
  );
};
